import * as React from "react";
const SvgUserLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 2a5 5 0 0 1 2.425 9.374A8 8 0 0 1 20 19v1a1 1 0 1 1-2 0v-1a6 6 0 0 0-12 0v1a1 1 0 1 1-2 0v-1c0-3.573 2.343-6.6 5.576-7.626A5 5 0 0 1 12 2m0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6", clipRule: "evenodd" }));
export default SvgUserLine;
